import React, { useEffect, useRef } from 'react'
import { useDownloadInstructionMutation, useGetAllInstructionRequestQuery } from '../../../services/announceElection';
import announcement from "../../../dashboardicon/announcement.png";
import download from '../../../dashboardicon/download.svg'
import { downloadFile } from '../../utilities/utils';
import axios from "axios";
import { BASE_URLS, PLATFORM_TYPE } from "../../../constants/constants";
const DownloadInstruction = () => {
    const {data:GetAllInstruction,refetch} = useGetAllInstructionRequestQuery()
    const [downloadCount,datap]=useDownloadInstructionMutation()
    console.log(GetAllInstruction)
    const detailsRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
         const detailsElement=document.getElementById("mydetails");
          if (detailsRef.current && !detailsRef.current.contains(event.target)) {
         //    console.log(document.getElementById("mydetails"))
      detailsElement.open=false;
          }
        }
     
        // Add the event listener when the component mounts
        document.addEventListener('click', handleClickOutside);
     
        // Remove the event listener when the component unmounts
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      },);


      useEffect(()=>{
        if(datap.isSuccess){
          refetch()
        }
      },[datap.isSuccess])

      const downloadFile = function (fileName,id) {
        const header = {
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
            currentRole: localStorage.userrole,
            appName: "ETPBMS",
            atkn_bnd: localStorage?.atkn_bnd,
      rtkn_bnd: localStorage?.rtkn_bnd,
      channelidobo: "ETPBMS",    
      "PLATFORM-TYPE":PLATFORM_TYPE
          },
        };
      
        axios
          .get(
            BASE_URLS.OBJECTSTORE_BASE_URL +
              `api/v1/document/getFile?bucketName=objectstorage&fileName=${fileName}`,
            header
          )
          .then((data) => {
            if (data) {
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              let fileExt = data.data.refId
                .split(".")
                [data.data.refId.split(".").length - 1]?.toLowerCase();
              const format = fileExt === ".pdf" ? "application/pdf" : "image/*";
              a.href = `data:${format};base64,` + data.data.file;
              a.download = fileName;
              a.click();
              document.body.removeChild(a);
            }
          }).then((res)=>{
            downloadCount({
              id:id
            })
          })
          .catch((err) => console.log("ERROR TO DOWNLOAD", err));
      };

  return (
    <>
  {GetAllInstruction && GetAllInstruction?.payload != null && <details id="mydetails" open ref={detailsRef}>
	<summary>Instructions<img src={announcement} style={{height:"20px",width:"20px"}}/></summary>
	<div className="abc">
			{
                GetAllInstruction?.payload?.filter((item)=>{
                    return item.isActive !=="N"}).map((item)=>{
                        return   (
                            <p>
                <div className="row subjectOfRelease">
                    <div className="col-md-12 ">
                   {item?.subject}
                    </div>
                    
          </div>
          <div className="row mt-2">
                    <div className="col-md-4 issueDateOfRelease">
                    Issued Date:- {item?.dateOfIssue}
                     </div>
                     <div className="col-md-4 expiryDateOfRelease ">
                    Expiry Date:- {item?.expiryDate}
                    </div>
                    <div className="col-md-3 NoOfDownloadRelease">
                    No Of Download:- {item?.downloadAttempts}
                    </div>
                     <div className="col-md-1 code">
                        <img src={download} onClick={()=>downloadFile(item?.filePath,item?.id)} style={{height:"26px",width:"26px"}}/>
                    </div>
          </div>
                      </p>
                        )
                    })
            }
	</div>
</details>}
    </>
  )
}



export default DownloadInstruction